const cardItems = [
  {
    title: '流浪地球3：星际远征',
    desc: '人类文明面临全新挑战，地球启航迈向未知宇宙。国产科幻巅峰之作，视觉奇观震撼呈现。',
    tag: '科幻巨制',
    rating: '9.2',
    img: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20cinematic%20scene%20with%20distant%20galaxies%20and%20spaceships%2C%20warm%20coral%20and%20deep%20space%20contrast%2C%20epic%20scale%20and%20atmospheric%20lighting%2C%20dramatic%20composition%2C%20no%20text%20no%20people&width=600&height=380&seq=card-01&orientation=landscape',
  },
  {
    title: '长安十二时辰：夜不收',
    desc: '盛世长安暗流涌动，十二时辰内惊天密谋。古装悬疑巅峰回归，每一帧都是壁纸级画面。',
    tag: '古装悬疑',
    rating: '9.5',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20cityscape%20at%20dusk%20with%20lanterns%20and%20traditional%20architecture%2C%20warm%20golden%20and%20coral%20lighting%2C%20mysterious%20cinematic%20atmosphere%2C%20Tang%20dynasty%20aesthetic%2C%20no%20people%20no%20text&width=600&height=380&seq=card-02&orientation=landscape',
  },
  {
    title: '哪吒之天劫降临',
    desc: '天命不公便逆天而行！国漫动画电影新标杆，热血与泪水交织的东方神话史诗。',
    tag: '国漫巅峰',
    rating: '9.4',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20inspired%20art%20with%20floating%20celestial%20elements%2C%20dramatic%20clouds%20and%20divine%20light%2C%20warm%20coral%20and%20gold%20gradients%2C%20epic%20cinematic%20style%2C%20no%20text%20no%20people&width=600&height=380&seq=card-03&orientation=landscape',
  },
  {
    title: '狂飙：风云再起',
    desc: '扫黑除恶斗争进入深水区，正邪较量再升级。实力派演员倾情演绎，年度必看刑侦大剧。',
    tag: '刑侦大剧',
    rating: '9.3',
    img: 'https://readdy.ai/api/search-image?query=A%20gritty%20urban%20noir%20atmosphere%20with%20rain-slicked%20streets%20and%20neon%20reflections%2C%20warm%20amber%20and%20dark%20coral%20tones%2C%20tense%20cinematic%20mood%2C%20crime%20drama%20aesthetic%2C%20no%20text%20no%20people&width=600&height=380&seq=card-04&orientation=landscape',
  },
  {
    title: '深海迷航',
    desc: '神秘深海隐藏失落的文明，一场惊心动魄的冒险之旅。视觉特效震撼，沉浸式观影体验。',
    tag: '冒险奇幻',
    rating: '8.9',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20ocean%20with%20bioluminescent%20creatures%20and%20ancient%20ruins%2C%20aquatic%20blue-green%20with%20warm%20coral%20light%20rays%2C%20ethereal%20underwater%20cinematic%20composition%2C%20no%20people%20no%20text&width=600&height=380&seq=card-05&orientation=landscape',
  },
  {
    title: '边境风云',
    desc: '缉毒警察深入虎穴，边境线上生死较量。真实案件改编，紧张刺激全程无尿点。',
    tag: '动作犯罪',
    rating: '8.7',
    img: 'https://readdy.ai/api/search-image?query=Rugged%20border%20landscape%20at%20sunset%20with%20dusty%20roads%20and%20distant%20mountains%2C%20warm%20golden%20and%20coral%20light%2C%20tense%20dramatic%20atmosphere%2C%20cinematic%20action%20mood%2C%20no%20text%20no%20people&width=600&height=380&seq=card-06&orientation=landscape',
  },
  {
    title: '披荆斩棘4',
    desc: '顶流明星跨界挑战，突破自我极限。今夏最燃综艺回归，欢笑与泪水并存。',
    tag: '热门综艺',
    rating: '9.0',
    img: 'https://readdy.ai/api/search-image?query=A%20vibrant%20stage%20performance%20atmosphere%20with%20colorful%20spotlights%20and%20dynamic%20energy%2C%20warm%20coral%20and%20golden%20stage%20lighting%2C%20entertainment%20show%20aesthetic%2C%20excited%20crowd%20silhouettes%2C%20no%20clear%20faces%20no%20text&width=600&height=380&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              糖心影视编辑甄选，本周最值得观看的影视内容
            </p>
          </div>
          <a href="#ranking" className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer">
            查看完整榜单 <i className="ri-arrow-right-line ml-1 align-middle"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cardItems.slice(0, 3).map((item) => (
            <article
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 bg-background-950/70 backdrop-blur-sm rounded-lg">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-background-50 text-xs font-bold">{item.rating}</span>
                </div>
                <span className="absolute top-3 right-3 px-2.5 py-1 text-[10px] font-semibold bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {item.desc}
                </p>
                <div className="mt-3 pt-3 border-t border-background-100">
                  <span className="flex items-center gap-1.5 text-xs text-primary-600 font-medium">
                    <i className="ri-play-circle-line"></i>
                    立即观看
                  </span>
                </div>
              </div>
            </article>
          ))}
          {cardItems.slice(3, 7).map((item) => (
            <article
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 bg-background-950/70 backdrop-blur-sm rounded-lg">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-background-50 text-xs font-bold">{item.rating}</span>
                </div>
                <span className="absolute top-3 right-3 px-2.5 py-1 text-[10px] font-semibold bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {item.desc}
                </p>
                <div className="mt-3 pt-3 border-t border-background-100">
                  <span className="flex items-center gap-1.5 text-xs text-primary-600 font-medium">
                    <i className="ri-play-circle-line"></i>
                    立即观看
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}